export default __webpack_public_path__ + "static/media/je.f4373cb2.svg";